/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-05-09 15:41:01
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-08-12 09:29:09
 * @FilePath: /wemeet-web-lobby/src/app/hooks/useRainbowConfig.ts
 * @Description: 获取
 */
import useSWR from 'swr';
import getRainbowConfig from '@utils/rainbow/index';
import { useEffect, useState } from 'react';
import isShowNewRegistration from '@utils/registrationGray';

export const useRainbowConfig = (
  isVaid?: boolean,
): {
  res: {
    [key: string]: string;
  };
  error: unknown;
  mutate: Function;
} => {
  const { data, error, mutate } = useSWR(
    {
      url: '/events/api/rainbow',
      params: {
        isVaid,
      },
    },
    () => {
      if (isVaid) {
        return Promise.resolve({});
      }
      return getRainbowConfig();
    },
    {
      revalidateOnFocus: false,
    },
  );

  return {
    res: data,
    error,
    mutate,
  };
};

// 判断是否禁用logo跳转
export const useDisabledLogoRedirectConfig = (id: string) => {
  const [unShow, setUnShow] = useState<boolean>(false);
  const { res } = useRainbowConfig();
  const unShowList = res?.disabledHeadLogoEvents;

  useEffect(() => {
    if (unShowList !== undefined) {
      const nUnShow = !!(id && unShowList.includes(id));

      setUnShow(nUnShow);
    }
  }, [res, id]);

  return unShow;
};
// 返回当前主办方访问报名页链接
export const useHostRegistrationUrl = (hostId?: string | number) => {
  const { res } = useRainbowConfig(!hostId);
  if (!hostId) return `${location.origin}/events/host/event/[eventId]/registration`;
  const isShowNew = isShowNewRegistration(res, hostId);
  const url = isShowNew
    ? `${location.origin}/events/[eventId]/registration`
    : `${location.origin}/events/host/event/[eventId]/registration`;
  return url;
};
